<template>
  <el-row class="server">
    <el-tooltip class="item" effect="dark" content="投诉建议" placement="right">
      <div class="tag">
        <i class="xy xy-icon43 "></i>
      </div>
    </el-tooltip>
  </el-row>
</template>
<script>
import { isSuccess } from "@/assets/js/utils";
export default {
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.server {
  position: fixed;
  right: 100px;
  bottom: 200px;
  z-index: 1024;
  text-align: center;
  width: 60px;
  height: 60px;
  line-height: 60px;
  background-color: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 30px;
  .tag{
    i{
      font-size: 30px;
      color: #333;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer/customer-service.vue